const Services = () => {
  return (
    <section className="section services" id="services">
      <div className="container">
        <h2 className="section-title">OUR SERVICES</h2>
        <p className="section-subtitle">
          Professional eye care & quality products you can trust
        </p>

        <div className="services-grid">

          {/* Eye Check-Up */}
          <div className="service-card">
            <img
              src="/images/eye-test.jpg"
              alt="Computerized Eye Check-Up in Masrakh"
              className="service-image"
            />
            <h3>Computerized Eye Check-Up</h3>
            <p>
              Accurate computerized eye testing with proper guidance.
              Safe and suitable for kids, adults & senior citizens.
            </p>
          </div>

          {/* Spectacles */}
          <div className="service-card">
            <img
              src="/images/spectacles.jpg"
              alt="Spectacle fitting and lens adjustment"
              className="service-image"
            />
            <h3>Spectacles & Lens Fitting</h3>
            <p>
              Perfect fitting with correct power and comfort guaranteed.
              Single vision, bifocal & progressive lenses available.
            </p>
          </div>

          {/* Watches */}
          <div className="service-card">
            <img
              src="/images/watches.jpg"
              alt="Watches for men women and kids"
              className="service-image"
            />
            <h3>Watches (Men • Women • Kids)</h3>
            <p>
              Stylish, durable and affordable watches.
              From daily wear to premium collections.
            </p>
          </div>

        </div>

        {/* Services CTA */}
        

      </div>
    </section>
  );
};

export default Services;
